import React, {useState} from "react";
import style from "./block.module.scss";
import {ReactComponent as Arrow} from "../assets/arrow.svg";
import {AdherentModal} from "../modal/Modal";
import apiFetch from '@wordpress/api-fetch';

export default function AdherentLoginForm({open, setVisibility, openRecovery, openSignup}) {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [alert, setAlert] = useState();
    const [loading, setLoading] = useState(false);

    const handleChange = event => {
        if(event.target.name === "email") {
            setEmail(event.target.value);
        } else if (event.target.name === "password") {
            setPassword(event.target.value);
        }
    };

    const loggin = () => {
        setAlert();
        
        const emailRegex = new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
        if(!email || !emailRegex.test(email)) {
            return setAlert({type: 'error', message: "L'email saisi est incorrect"});
        }

        setLoading(true);

        try {
            apiFetch( {
                    path: "/adherent/v1/login",
                    method: 'POST',
                    data: { username: email, password },
                })
                .then(data => {
                    setAlert({type: 'success', message: "Connexion réussie ! Redirection dans 5 secondes..."});
                    window.location.reload(false);
                })
                .catch(err => {
                    setAlert({type: 'error', message: "Les identifiants sont incorrects."});
                    setLoading(false);
                });
        } catch (e) {
            setAlert({type: 'error', message: "Une erreur est survenue"});
            setLoading(false);
        }
        
    };

    return (
        <AdherentModal open={open} setVisibility={setVisibility}>
                <div className={style.textBloc}>
                            <h2 className={style.title}>Espace adhérents</h2>
                            <hr className={style.separator}/>
                            <p className={style.condition}>Cet espace est réservé aux adhérents de l’Alliance des Crus Bourgeois du Médoc. <br/> Merci de remplir vos identifiants et mot de passe pour vous connecter.</p>
                            <div className={style.formContainer}>
                                <input onChange={handleChange} type="text" name="email" placeholder="Email" />
                                <input onChange={handleChange} type="password" name="password" placeholder="Mot de passe" />
                                {alert && <p className={[style.alert, style[alert.type]].join(" ")} >{alert.message}</p>}
                                <button className={style.forgetPassword} href="#" onClick={() => openRecovery(true)}>Mot de passe oublié ?</button>
                            </div>
                            <div className={style.loginButtonContainer}>
                                <Arrow className={style.loginIcon}/>
                                <button className={style.loginButton} onClick={loggin}>Se connecter</button>
                            </div>
                            <div className={style.singupContainer}>
                                <Arrow className={style.signUpIcon}/>
                                <button disabled={loading} className={style.signUpText} onClick={() => openSignup(true)}>Créer votre espace adhérent</button>
                            </div>
                        </div>
        </AdherentModal>
    )
}